import * as React from "react";
import { useCallback, useMemo, useState } from "react";
import ExpandedEventDetails from "security-app/components/SecurityEvents/Alerts/ExpandedEventDetails";
import BulkActions from "../BulkActions";
const useTableElements = ({ defaultLayout }) => {
  const renderExpandedRow = useCallback(
    (event) => /* @__PURE__ */ React.createElement(ExpandedEventDetails, { securityEvent: event, defaultLayout }),
    [defaultLayout]
  );
  const expandedSections = useMemo(
    () => ({
      restFieldsExpandedSection: {
        title: "Details",
        content: renderExpandedRow
      }
    }),
    [renderExpandedRow]
  );
  const [selectedEntitiesData, setSelectedEntitiesData] = useState({});
  const bulkSelection = useMemo(
    () => ({
      onChangeSelection: (selectedItemsIds, list) => {
        setSelectedEntitiesData((cur) => {
          const uniqueSelectedIds = [...new Set(selectedItemsIds)];
          const eventsMap = Object.fromEntries(list.map((event) => [event.id, event]));
          return Object.fromEntries(
            uniqueSelectedIds.map((selectedItemId) => {
              var _a;
              return [
                selectedItemId,
                (_a = cur[selectedItemId]) != null ? _a : eventsMap[selectedItemId]
              ];
            })
          );
        });
      },
      actions: /* @__PURE__ */ React.createElement(BulkActions, { selectedEntitiesData })
    }),
    [selectedEntitiesData]
  );
  return {
    expandedSections,
    bulkActions: /* @__PURE__ */ React.createElement(BulkActions, { selectedEntitiesData }),
    bulkSelection
  };
};
export default useTableElements;
